import React, { useState, useEffect } from 'react';
import { Checkbox } from '@mui/material';
import Button from '@mui/material/Button';
import connect from "react-redux/es/components/connect";
import translate from "../i18n/translate";
import { actionToggleFooter, actionToggleNavBar, actionToggleSideBar } from "../store/action/LayoutActionSupervisor";
import { client, actionGetDefaultAccessRights, getAccessRightsForPageID } from "../store/action/RemoteActionSupervisor";
import { getMultiLanguageMessage } from "../i18n/multiLanguage";
import { PAGELABEL, ACCESSRIGHTS, PAGEID, ACCESSRIGHTSTYPE } from "../i18n/constants";

let BASE_URL = process.env.REACT_APP_SERVER_URL_API;

const DefaultAccessRights = (props) => {
    const [language, setLanguage] = useState("");
    const [pageAccessRights, setPageAccessRights] = useState({});
    const [defaultAccessRights, setDefaultAccessRights] = useState([]);
    const [isReadAllAccess, setIsReadAllAccess] = useState(false);
    const [isWriteAllAccess, setIsWriteAllAccess] = useState(false);
    const [isDeleteAllAccess, setIsDeleteAllAccess] = useState(false);
    const [isImportAllAccess, setIsImportAllAccess] = useState(false);
    const [isExportAllAccess, setIsExportAllAccess] = useState(false);
    const [isVerifyAllAccess, setIsVerifyAllAccess] = useState(false);
    const [isApproveAllAccess, setIsApproveAllAccess] = useState(false);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);
    const [changeStatus, setChangeStatus] = useState(false); //Trigger page rendering

    const handleAccessRightsChange = (e, index, accessRightType) => {
        if (index < 0 || defaultAccessRights.length <= index || !e) return;

        let nAccessRight = e.target.checked ? 2 : 1;
        if (accessRightType === ACCESSRIGHTS.Read) {
            defaultAccessRights[index].ReadAccess = nAccessRight;
        } else if (accessRightType === ACCESSRIGHTS.Write) {
            defaultAccessRights[index].WriteAccess = nAccessRight;
        } else if (accessRightType === ACCESSRIGHTS.Delete) {
            defaultAccessRights[index].DeleteAccess = nAccessRight;
        } else if (accessRightType === ACCESSRIGHTS.Import) {
            defaultAccessRights[index].ImportAccess = nAccessRight;
        } else if (accessRightType === ACCESSRIGHTS.Export) {
            defaultAccessRights[index].ExportAccess = nAccessRight;
        } else if (accessRightType === ACCESSRIGHTS.Verify) {
            defaultAccessRights[index].VerifyAccess = nAccessRight;
        } else if (accessRightType === ACCESSRIGHTS.Approve) {
            defaultAccessRights[index].ApprovalAccess = nAccessRight;
        }
        defaultAccessRights[index].IsModified = true;
        setChangeStatus(!changeStatus);
    };

    const selectAllAccessRights = (e, accessRightType) => {
        if (defaultAccessRights.length <= 0) return;

        let isChecked = e.target.checked;
        let index = 0;
        for (index = 0; index < defaultAccessRights.length; index++) {
            if (accessRightType === ACCESSRIGHTS.Read) {
                if (defaultAccessRights[index].ReadAccess === 0) {
                    continue;
                } else {
                    defaultAccessRights[index].ReadAccess = isChecked ? 2 : 1;
                }
            } else if (accessRightType === ACCESSRIGHTS.Write) {
                if (defaultAccessRights[index].WriteAccess === 0) {
                    continue;
                } else {
                    defaultAccessRights[index].WriteAccess = isChecked ? 2 : 1;
                }
            } else if (accessRightType === ACCESSRIGHTS.Delete) {
                if (defaultAccessRights[index].DeleteAccess === 0) {
                    continue;
                } else {
                    defaultAccessRights[index].DeleteAccess = isChecked ? 2 : 1;
                }
            } else if (accessRightType === ACCESSRIGHTS.Import) {
                if (defaultAccessRights[index].ImportAccess === 0) {
                    continue;
                } else {
                    defaultAccessRights[index].ImportAccess = isChecked ? 2 : 1;
                }
            } else if (accessRightType === ACCESSRIGHTS.Export) {
                if (defaultAccessRights[index].ExportAccess === 0) {
                    continue;
                } else {
                    defaultAccessRights[index].ExportAccess = isChecked ? 2 : 1;
                }
            } else if (accessRightType === ACCESSRIGHTS.Verify) {
                if (defaultAccessRights[index].VerifyAccess === 0) {
                    continue;
                } else {
                    defaultAccessRights[index].VerifyAccess = isChecked ? 2 : 1;
                }
            } else if (accessRightType === ACCESSRIGHTS.Approve) {
                if (defaultAccessRights[index].ApprovalAccess === 0) {
                    continue;
                } else {
                    defaultAccessRights[index].ApprovalAccess = isChecked ? 2 : 1;
                }
            }
            defaultAccessRights[index].IsModified = true;
        }

        if (accessRightType === ACCESSRIGHTS.Read) {
            setIsReadAllAccess(isChecked);
        } else if (accessRightType === ACCESSRIGHTS.Write) {
            setIsWriteAllAccess(isChecked);
        } else if (accessRightType === ACCESSRIGHTS.Delete) {
            setIsDeleteAllAccess(isChecked);
        } else if (accessRightType === ACCESSRIGHTS.Import) {
            setIsImportAllAccess(isChecked);
        } else if (accessRightType === ACCESSRIGHTS.Export) {
            setIsExportAllAccess(isChecked);
        } else if (accessRightType === ACCESSRIGHTS.Verify) {
            setIsVerifyAllAccess(isChecked);
        } else if (accessRightType === ACCESSRIGHTS.Approve) {
            setIsApproveAllAccess(isChecked);
        }
        setChangeStatus(!changeStatus);
    };

    const updateAccessRights = async () => {
        let index = 0;
        let modifiedAccessRights = [];
        for (index = 0; index < defaultAccessRights.length; index++) {
            if (defaultAccessRights[index].IsModified) {
                modifiedAccessRights.push(defaultAccessRights[index]);
            }
        }

        if (modifiedAccessRights.length === 0) {
            alert(getMultiLanguageMessage('msg_NoChangesMade_Error', language));
            return;
        }

        if (window.confirm(getMultiLanguageMessage('msg_Update_Confirm', language))) {
            setIsButtonClicked(true);
            const params = {
                VfaspID: process.env.REACT_APP_VFASP_CODE,
                AdminID: localStorage.getItem("supervisorid"),
                AccessRightList: modifiedAccessRights
            };
            await client(localStorage.getItem("supervisortoken")).put(`${BASE_URL}/accessrights/default/update`, params).then((response) => {
                setIsSubmitSuccess(true);
            }).catch(error => {
                alert(getMultiLanguageMessage('msg_Server_Error', language));
                setIsSubmitSuccess(false);
            });

            setDefaultAccessRights([]);
            props.actionGetDefaultAccessRights({});
            setIsButtonClicked(false);
        }
    };

    useEffect(() => {
        if (props?.defaultAccessRights?.length > 0) {
            setDefaultAccessRights(props.defaultAccessRights);
            let index = 0;
            let isReadAllSelected = true;
            let isWriteAllSelected = true;
            let isDeleteAllSelected = true;
            let isImportAllSelected = true;
            let isExportAllSelected = true;
            let isVerifyAllSelected = true;
            let isApproveAllSelected = true;
            for (index = 0; index < props.defaultAccessRights.length; index++) {
                if (props.defaultAccessRights[index].ReadAccess === 1) {
                    isReadAllSelected = false;
                }
                if (props.defaultAccessRights[index].WriteAccess === 1) {
                    isWriteAllSelected = false;
                }
                if (props.defaultAccessRights[index].DeleteAccess === 1) {
                    isDeleteAllSelected = false;
                }
                if (props.defaultAccessRights[index].ImportAccess === 1) {
                    isImportAllSelected = false;
                }
                if (props.defaultAccessRights[index].ExportAccess === 1) {
                    isExportAllSelected = false;
                }
                if (props.defaultAccessRights[index].VerifyAccess === 1) {
                    isVerifyAllSelected = false;
                }
                if (props.defaultAccessRights[index].ApprovalAccess === 1) {
                    isApproveAllSelected = false;
                }
            }
            setIsReadAllAccess(isReadAllSelected);
            setIsWriteAllAccess(isWriteAllSelected);
            setIsDeleteAllAccess(isDeleteAllSelected);
            setIsImportAllAccess(isImportAllSelected);
            setIsExportAllAccess(isExportAllSelected);
            setIsVerifyAllAccess(isVerifyAllSelected);
            setIsApproveAllAccess(isApproveAllSelected);
        }
    }, [props.defaultAccessRights]);

    useEffect(() => {
        if (props?.supervisor?.length > 0) {
        }
    }, [props.supervisor]);

    useEffect(() => {
        let selectedLanguage = localStorage.getItem("locale");
        setLanguage(selectedLanguage);
        let accessRights = getAccessRightsForPageID(PAGEID.DefaultAdminAccessRights);
        setPageAccessRights(accessRights);
        if (accessRights && accessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes) {
            props.actionGetDefaultAccessRights({});
        } else {
            alert(getMultiLanguageMessage('Msg_InvalidAccessRights', selectedLanguage));
        }
    }, []);

    return ((props?.supervisor?.length > 0 && pageAccessRights && pageAccessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes)) ? (
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-DefaultAccessRights')}</h2>

            {/* .nav-tabs-line */}
            <div className="tab-content" id="security-opt-tab">
                {/* .tab-pane */}
                <div className="tab-pane active show" id="password-opt">
                    <form action="#">
                        {/* .row */}

                        <table className="adminTable" width='100%'>
                            <tbody>
                                <tr className="adminTR">
                                    <th className="adminTH" style={{ width: '30%' }}>{translate('PageName')}</th>
                                    <th className="adminTH" style={{ width: '10%' }}>{translate('ReadAccess')}</th>
                                    <th className="adminTH" style={{ width: '10%' }}>{translate('WriteAccess')}</th>
                                    <th className="adminTH" style={{ width: '10%' }}>{translate('DeleteAccess')}</th>
                                    <th className="adminTH" style={{ width: '10%' }}>{translate('ImportAccess')}</th>
                                    <th className="adminTH" style={{ width: '10%' }}>{translate('ExportAccess')}</th>
                                    <th className="adminTH" style={{ width: '10%' }}>{translate('VerifyAccess')}</th>
                                    <th className="adminTH" style={{ width: '10%' }}>{translate('ApprovalAccess')}</th>
                                </tr>
                                {(defaultAccessRights?.length > 0) &&
                                    <tr className="adminTR" key={'chkSelectAll'}>
                                        <td className="adminTD" width='30%' align='center'></td>
                                        <td className="adminTD" width='10%' align='center'>
                                            <Checkbox checked={isReadAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Read)} name={"id_ReadAccessAll"} id={"id_ReadAccessAll"} />{translate('SelectAll')}
                                        </td>
                                        <td className="adminTD" width='10%' align='center'>
                                            <Checkbox checked={isWriteAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Write)} name={"id_WriteAccessAll"} id={"id_WriteAccessAll"} />{translate('SelectAll')}
                                        </td>
                                        <td className="adminTD" width='10%' align='center'>
                                            <Checkbox checked={isDeleteAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Delete)} name={"id_DeleteAccessAll"} id={"id_DeleteAccessAll"} />{translate('SelectAll')}
                                        </td>
                                        <td className="adminTD" width='10%' align='center'>
                                            <Checkbox checked={isImportAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Import)} name={"id_ImportAccessAll"} id={"id_ImportAccessAll"} />{translate('SelectAll')}
                                        </td>
                                        <td className="adminTD" width='10%' align='center'>
                                            <Checkbox checked={isExportAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Export)} name={"id_ExportAccessAll"} id={"id_ExportAccessAll"} />{translate('SelectAll')}
                                        </td>
                                        <td className="adminTD" width='10%' align='center'>
                                            <Checkbox checked={isVerifyAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Verify)} name={"id_VerifyAccessAll"} id={"id_VerifyAccessAll"} />{translate('SelectAll')}
                                        </td>
                                        <td className="adminTD" width='10%' align='center'>
                                            <Checkbox checked={isApproveAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Approve)} name={"id_ApprovalAccessAll"} id={"id_ApprovalAccessAll"} />{translate('SelectAll')}
                                        </td>
                                    </tr>
                                }
                                {defaultAccessRights?.map((accessRight, index) => {
                                    let sPageLabel = '' + PAGELABEL[accessRight.PageID] + '';
                                    return <tr className="adminTR" key={accessRight.AUTORECID}>
                                        <td className='adminTD' width='30%' align='left'>{translate(sPageLabel)}</td>
                                        <td className='adminTD' width='10%' align='center'>
                                            {(accessRight.ReadAccess > 0) &&
                                                <Checkbox checked={(accessRight.ReadAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Read)} name={"id_ReadAccess_" + accessRight.AUTORECID} id={"id_ReadAccess_" + accessRight.AUTORECID} />
                                            }
                                        </td>
                                        <td className='adminTD' width='10%' align='center'>
                                            {(accessRight.WriteAccess > 0) &&
                                                <Checkbox checked={(accessRight.WriteAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Write)} name={"id_WriteAccess_" + accessRight.AUTORECID} id={"id_WriteAccess_" + accessRight.AUTORECID} />
                                            }
                                        </td>
                                        <td className='adminTD' width='10%' align='center'>
                                            {(accessRight.DeleteAccess > 0) &&
                                                <Checkbox checked={(accessRight.DeleteAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Delete)} name={"id_DeleteAccess_" + accessRight.AUTORECID} id={"id_DeleteAccess_" + accessRight.AUTORECID} />
                                            }
                                        </td>
                                        <td className='adminTD' width='10%' align='center'>
                                            {(accessRight.ImportAccess > 0) &&
                                                <Checkbox checked={(accessRight.ImportAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Import)} name={"id_ImportAccess_" + accessRight.AUTORECID} id={"id_ImportAccess_" + accessRight.AUTORECID} />
                                            }
                                        </td>
                                        <td className='adminTD' width='10%' align='center'>
                                            {(accessRight.ExportAccess > 0) &&
                                                <Checkbox checked={(accessRight.ExportAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Export)} name={"id_ExportAccess_" + accessRight.AUTORECID} id={"id_ExportAccess_" + accessRight.AUTORECID} />
                                            }
                                        </td>
                                        <td className='adminTD' width='10%' align='center'>
                                            <Checkbox checked={(accessRight.VerifyAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Verify)} name={"id_VerifyAccess_" + accessRight.AUTORECID} id={"id_VerifyAccess_" + accessRight.AUTORECID} />
                                        </td>
                                        <td className='adminTD' width='10%' align='center'>
                                            <Checkbox checked={(accessRight.ApprovalAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Approve)} name={"id_ApprovalAccess_" + accessRight.AUTORECID} id={"id_ApprovalAccess_" + accessRight.AUTORECID} />
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>

                        {isButtonClicked &&
                            <>
                                <div className="gaps" />
                                <img width={80} src={require('../assets/images/loading.gif')} srcSet={require('../assets/images/loading.gif')} alt="loading" />
                            </>
                        }
                        <div className="gaps-2x" />
                        <div className="d-sm-flex justify-content-between align-items-center">
                            <div className="gaps-2x d-sm-none" />
                            <span className="color-success">
                                {isSubmitSuccess &&
                                    <div>
                                        <em className="ti ti-check-box" /> {translate('Update-Success-Message')}
                                        <div className="gaps-1x" />
                                    </div>
                                }
                            </span>
                        </div>

                        {/* 10px gap */}
                        <div className="d-sm-flex justify-content-between align-items-center">
                            <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => updateAccessRights()}>{translate('btnUpdate')}</Button>
                            <div className="gaps-2x d-sm-none" />
                        </div>
                    </form>
                    {/* form */}
                </div>
                {/* .tab-pane */}
            </div>
            {/* .tab-content */}
        </div>
    ) : '';
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
        supervisor: state.remote.supervisor,
        defaultAccessRights: state.remote.defaultAccessRightList
    };
};

export default connect(mapStateToProps, {
    actionToggleNavBar,
    actionToggleSideBar,
    actionToggleFooter,
    actionGetDefaultAccessRights
})(DefaultAccessRights);
